<template>
  <div class="oauth-tutorial-banner">
    <div class="oauth-tutorial-banner__icon" aria-hidden="true">
      <i class="fas fa-book-open" />
    </div>
    <div class="oauth-tutorial-banner__body">
      <strong>{{ title }}</strong>
      <p>{{ description }}</p>
    </div>
    <router-link
      class="oauth-tutorial-banner__link"
      :to="{ name: 'oauthIntegracaoTutorial' }"
      tag="button"
      type="button"
    >
      {{ linkLabel }}
      <i class="fas fa-arrow-right" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'OAuthTutorialBanner',
  props: {
    title: {
      type: String,
      default: 'Tutorial de integração OAuth',
    },
    description: {
      type: String,
      default: 'Escolha o tutorial certo para o seu cenário: frontend, híbrida ou backend.',
    },
    linkLabel: {
      type: String,
      default: 'Abrir tutorial',
    },
  },
};
</script>

<style scoped>
.oauth-tutorial-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--spacing-md);
  margin-bottom: var(--spacing-lg);
  padding: var(--spacing-md);
  border: 1px solid var(--border-primary);
  border-radius: var(--border-radius-md);
  background: color-mix(in srgb, var(--color-primary) 8%, var(--bg-primary));
}

.oauth-tutorial-banner__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--border-radius-sm);
  background: linear-gradient(135deg, var(--color-primary), var(--color-secondary));
  color: var(--text-inverse);
  font-size: 1rem;
}

.oauth-tutorial-banner__body {
  flex: 1;
  min-width: 220px;
}

.oauth-tutorial-banner__body strong {
  display: block;
  margin-bottom: var(--spacing-xs);
  color: var(--text-primary);
  font-size: 0.95rem;
}

.oauth-tutorial-banner__body p {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-secondary);
  line-height: 1.45;
}

.oauth-tutorial-banner__link {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: 0.5rem 0.9rem;
  border: none;
  border-radius: var(--border-radius-sm);
  background: var(--color-primary);
  color: var(--text-inverse);
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
}

.oauth-tutorial-banner__link:hover {
  opacity: 0.92;
  color: var(--text-inverse);
  text-decoration: none;
}
</style>
